(ns frontend.actions.excel-export
  (:require [frontend.conn :as conn]
            [promesa.core :as p]
            [frontend.logging :as logging]))

;;full list of exports:
(defn *->exports [data on-success on-error]
  (-> (conn/sendp! :export/export-history data)
      (p/then (fn [args]
                (on-success (:body args))))
      (p/catch (fn [e]
                 (logging/error "Unable to get list of exports" e)
                 (on-error e)))))

;;full list of logins
(defn *->logins [data on-success on-error]
  (-> (conn/sendp! :export/login-history data)
      (p/then (fn [args]
                (on-success (:body args))))
      (p/catch (fn [e]
                 (logging/error "Unable to get list of logins" e)
                 (on-error e)))))
